// extracted by mini-css-extract-plugin
module.exports = {"title":"Characters_title__3Q3A2","active":"Characters_active__1kUhb"};